import OpticksSvgElement from "@/components/ui/OpticksSvgElement/OpticksSvgElement";
import type { OpticksSvgElementProps } from "@/components/ui/OpticksSvgElement/OpticksSvgElement.types";

// Collection: Tabler Icons
const PointerIcon = ({
  className,
  size = 16,
  "aria-label": ariaLabel,
}: OpticksSvgElementProps) => (
  <OpticksSvgElement
    className={`icon-pointer${className ? ` ${className}` : ""}`}
    size={size}
    aria-label={ariaLabel}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path
      d="M5.26929 11.7087C5.30475 11.8679 5.38806 12.0126 5.50806 12.1231C5.62805 12.2337 5.77899 12.305 5.94063 12.3273C6.10227 12.3497 6.26688 12.322 6.41237 12.2482C6.55787 12.1743 6.67729 12.0577 6.75463 11.914L8.14796 9.852L11.4193 13.1233C11.4853 13.1894 11.5638 13.2418 11.6501 13.2775C11.7364 13.3133 11.8289 13.3317 11.9223 13.3317C12.0157 13.3317 12.1082 13.3133 12.1945 13.2775C12.2808 13.2418 12.3592 13.1894 12.4253 13.1233L13.1233 12.4253C13.1893 12.3593 13.2417 12.2809 13.2775 12.1946C13.3132 12.1082 13.3316 12.0157 13.3316 11.9223C13.3316 11.8289 13.3132 11.7364 13.2775 11.6501C13.2417 11.5638 13.1893 11.4854 13.1233 11.4193L9.85196 8.148L11.9273 6.75466C12.071 6.67728 12.1876 6.5578 12.2614 6.41226C12.3352 6.26672 12.3628 6.10208 12.3404 5.94042C12.3179 5.77877 12.2466 5.62785 12.136 5.50789C12.0253 5.38794 11.8806 5.30469 11.7213 5.26933L2.66663 2.66666L5.26929 11.7087Z"
      id="icon-stroke"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </OpticksSvgElement>
);

export default PointerIcon;
